import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppRole } from '@shared/auth/enums/app-role.enum';
import { RoleAccessService } from '@shared/auth/services/role-access.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@shared/components/base.component';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { Config } from '@shared/configs/config';
import { ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { filter, tap } from 'rxjs';

export enum ActionType {
  EDIT = 'edit',
  BLOCK = 'block',
  UNBLOCK = 'unblock',
  SEND_PASSWORD = 'sendPassword',
  SEND_INVITE = 'sendInvite',
  REMOVE = 'remove'
}

@Component({
  selector: 'app-team-card',
  templateUrl: './team-card.component.html',
  styleUrls: ['./team-card.component.scss']
})
export class TeamCardComponent extends BaseComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly roleAccessService = inject(RoleAccessService);
  protected readonly AppRole = AppRole;

  ActionType = ActionType;

  @Input() role: string = '';
  @Input() previewName: string = '';
  @Input() salary: string = '';
  @Input() address: string = '';
  @Input() active: boolean = false;
  @Output() emitAction: EventEmitter<ActionType> = new EventEmitter();

  constructor() {
    super();
  }

  onEmitAction(type: ActionType) {
    this.emitAction.emit(type);
  }

  protected removeUser(): void {
    if (!this.roleAccessService.hasRole(AppRole.ADMIN)) return;

    this.dialog
      .open(ConfirmModalComponent, {
        width: Config.CONFIRM_MODAL_WIDTH,
        autoFocus: false,
        data: {
          title: 'RemoveData.title',
          body: 'RemoveData.description',
          submitButtonText: 'RemoveData.confirm',
          submitButtonType: ButtonTypes.NEW_RED,
          submitButtonIcon: './assets/img/ic-warning-v2.svg'
        }
      })
      .afterClosed()
      .pipe(
        filter((confirm): confirm is boolean => !!confirm),
        tap(() => this.onEmitAction(ActionType.REMOVE)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
